export default "__VITE_ASSET__DLNhIpUb__"